<template>
  <div class="Report__Entity">
    <Entity
      ref="entity"
      entity-type="VirtualContract"
      :entity-id="contractId"
      :innerComponent="innerComponent"
      innerComponentTitle="פרטי חוזה נקודתי"
      title="חוזה נקודתי"
      back-button-text="רשימת רכבים"
      back-button-url="vehicles"
      :widgets="widgets"
      :preview="preview"
      :read-only="true"
      :entityReady="entityReady"
      :activities="[]"
    >
      <template #mandatory>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">שוכר:</span>
          <span class="Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold">{{ Profile ? Profile.Name : '' }}</span>
        </div>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">חברת ליסינג:</span>
          <span class="Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold">{{ ContractOwner ? ContractOwner.Name : '' }}</span>
        </div>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">תאריך תחילה:</span>
          <span class="Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"><FieldDateHourInline :value="StartDate" /></span>
        </div>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">תאריך סיום:</span>
          <span class="Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"><FieldDateHourInline :value="EndDate" /></span>
        </div>
        <div class="Accident__Entity__Details__BaseDetails__Stage">
          <span class="ltr">תאריך עדכון:</span>
          <span class="Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"><FieldDateHourInline :value="UpdateDate" /></span>
        </div>
      </template>
    </Entity>
  </div>
</template>

<script>
import Entity from "@/components/Entity.vue";
import VirtualContractEntityDetails from "@/components/VirtualContractEntityDetails.vue";
import { mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import FieldDateHourInline from "@/components/Fields/FieldDateHourInline.vue";
import WidgetService from "../services/WidgetService";

const { mapFields } = createHelpers({
  getterType: "virtualContract/getField",
  mutationType: "virtualContract/updateField",
});

export default {
  components: {
    Entity,
    FieldDateHourInline,
  },
  props: ["id", "preview"],
  computed: {
    contractId() {
      return this.$route.params.id || this.id;
    },
    isAdmin() {
      return this.$store.state.auth?.user?.claims?.isAdmin === "True";
    },
    widgets() {
      return [
        { ...WidgetService.Profile, namespace: "virtualContract" },
        {
          ...WidgetService.VirtualContractDocuments,
          namespace: "virtualContract",
          documentType: "TransferHtml",
          title: "הצהרת חוכר",
        },
        {
          ...WidgetService.VirtualContractDocuments,
          namespace: "virtualContract",
          documentType: "RentalPickUpFormHtml",
          title: "טופס איסוף השכרה",
        },
        {
          ...WidgetService.VirtualContractDocuments,
          namespace: "virtualContract",
          documentType: "RentalReturnFormHtml",
          title: "טופס החזרת השכרה",
        },
        {
          ...WidgetService.VirtualContractDocuments,
          namespace: "virtualContract",
          documentType: "DriversLicenseHtml",
          title: "רישיון נהיגה",
        },
      ];
    },
    innerComponent() {
      return VirtualContractEntityDetails;
    },
    ...mapFields(["StartDate", "EndDate", "UpdateDate", "Profile", "ContractOwner"]),
  },
  data() {
    return {
      entityReady: false,
    };
  },
  async created() {
    this.init();
  },
  methods: {
    async init(callback) {
      try {
        const loadAction = this.isAdmin ? this.loadAdmin : this.load;
        await loadAction({
          id: this.contractId,
        });
        this.entityReady = true;
        if (callback) {
          callback();
        }
      } catch (err) {
        console.log(err);
      }
    },
    ...mapActions({
      load: "virtualContract/loadVirtualContract",
      loadAdmin: "virtualContract/loadVirtualContractAdmin",
    }),
  },
};
</script>

<style>
</style>
